import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BillingAlerts = lazy(() =>
  import("@scenes/BillingAlerts/BillingAlerts").then((module) => ({
    default: module.BillingAlerts,
  }))
);

export const billingAlertsNRO: NavigationRoutingObject = {
  Component: BillingAlerts,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("billing-alerts-sidebar-menu-option", "Billing Alerts"),
  pageNameForTracking: () => "Billing Alerts",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    // Keep in sync with billingAlertsUsageManagementNRO and the Billing Alerts link in SettingsMenuItems
    return (
      featureOn("enable_billing_governance_controls") && hasPermission("appGroup", { permission: "viewBilling" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/billing_alerts/:appGroupId",
};
